enum ActionTypes {
    SAVE_DEALER_GROUPS = "SAVE_DEALER_GROUPS",
    SET_ACTIVE_DEALER_GROUP = "SET_ACTIVE_DEALER_GROUP",
    LOADING_DEALER_GROUPS = "LOADING_DEALER_GROUPS",
    LOADING_ORG_MEMBERS = "LOADING_ORG_MEMBERS",
    LOGOUT_ACTION = "LOGOUT_ACTION",
}

export default ActionTypes;
